import { useBrandQuery } from "../../graphql/query";
import { BrandPartsFragment } from "../../gql/graphql";

type UseBrand = {
  brand: BrandPartsFragment;
  loading: boolean;
};
export function useBrand(brandId: number | null): UseBrand {
  const { loading, data } = useBrandQuery(brandId);
  const brand = (data?.getBrand as BrandPartsFragment) || {
    id: 0,
    gpmDangerThreshold: 0,
    organisationPmsName: "",
    taxLevelPercent: 0,
    isDefault: false,
    numberedListFormat: "brackets",
    lineBreakInLists: false,
  };

  return { brand, loading };
}
